exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-ebc4c05e]{padding:var(--box-pad);--color-light:#fff;--color-dark:#000}.box *[data-v-ebc4c05e]{color:inherit}", ""]);

// exports
